import { useCallback } from 'react'

import { CartFragment } from '../../../../graphql/magento'
import { CartType } from '../../reducers/cart-get-state'
import { CartUpdateAttributesVariables, useCartUpdateAttributes } from './useCartUpdateAttributes'

export type UseCartUpdateAfterMerge = {
  updateCartAfterMerge: (options: UpdateCartAfterMergeOptions) => Promise<CartFragment>
}

export type UpdateCartAfterMergeOptions = {
  token: string
  mergedCart: CartFragment
  cartDataForUpdate: CartDataForUpdate
  cartType: CartType
}

export type CartDataForUpdate = {
  cartAttributes: CartUpdateAttributesVariables
}

export type { CartUpdateAttributesVariables }

export const useCartUpdateAfterMerge = (): UseCartUpdateAfterMerge => {
  const { updateCartAttributes } = useCartUpdateAttributes()

  const updateCartAfterMerge = useCallback(
    async ({
      token,
      mergedCart,
      cartDataForUpdate: { cartAttributes },
      cartType,
    }: UpdateCartAfterMergeOptions): Promise<CartFragment> => {
      const { id: cartId } = mergedCart
      const updatedCart = await updateCartAttributes({
        token,
        cartId,
        cartAttributes,
        cartType,
      })
      if (updatedCart) {
        return updatedCart
      }
      return mergedCart
    },
    [updateCartAttributes],
  )

  return { updateCartAfterMerge }
}
